import { rows, DataGrid } from "colbi_web_ui/lib/components";
import { parseFilter } from "colbi_web_ui/lib/utils";
import Repository from "../controllers/Repository/Repository";
import RepositoryToolbar from "../components/RepositoryToolbar/RepositoryToolbar";
import RepositoryGeneratorFormButton from "../components/RepositoryGeneratorFormButton/RepositoryGeneratorFormButton";
import { getConfigVariable } from "../config/config";

const queries = (args = {}) => {
    return [
        {
            resource: args.section,
            args: {
                projectId: args.projectId,
                fiscalYear: args.fiscalYear || "",
                fileType: args.fileType || "",
                sort: args.sort
                    ? { type: "[SortInput!]", value: parseFilter(args.sort) }
                    : undefined,
                filter: args.filter
                    ? { type: "[FilterInput!]", value: parseFilter(args.filter) }
                    : undefined,
                page: parseInt(args.page, 10) || 0,
                pageSize: parseInt(
                    args.pageSize || getConfigVariable("REACT_APP_DEFAULT_PAGE_SIZE"),
                ),
            },
            body: `__typename, items{...${args.section}}, total, hasMore,filters(projectId:$projectId, fiscalYear:$fiscalYear){ prop, name, type, list, disableOperators, mandatory}`,
            downloadable: true,
            forceRefresh: true,
            isDatagridReq: true,
        },
        {
            resource: "show_terms_and_conditions",
            args: {
                projectId: args.projectId,
            },
            forceRefresh: true,
        },
        {
            resource: "project_modules",
            args: {
                projectId: args.projectId,
            },
            body: "modules",
        },
        {
            resource: "csv_delimiter",
            args: {
                projectId: args.projectId,
            },
            forceRefresh: true,
        },
        args.id
            ? {
                  resource: `${args.section}_detail`,
                  args: {
                      projectId: args.projectId,
                      fiscalYear: args.fiscalYear,
                      id: args.id,
                      locale: args.locale || "",
                  },
                  body: `...${args.section}_detail`,
              }
            : {},
    ].filter((r) => !!r.resource);
};

const newGeneration = (path, navigation, showGenerationButton) => ({
    path,
    navigation,
    component: Repository,
    exact: false,
    title: "files",
    headerComponentConfig: {
        showButton: true,
        type: "generation",
        showGenerationButton,
        endPointToRequest: "GenericRequest",
    },
    headerComponents: [{ component: RepositoryGeneratorFormButton }],
    queries,
    components: [
        {
            component: DataGrid,
            props: {
                id: "results",
                card: rows.CellCard,
                checkbox: true,
                items: "query(0).list",
                header: "query(0).header",
                footer: "query(0).footer",
                metadata: "query(0).metadata",
                page: "param(page)",
                status: "status(0)",
                sort: "param(sort)",
                pageSize: "param(pageSize)",
                pageDefault: 10,
                filter: "param(filter)",
                availableFilters: "query(0).filters",
                wrapper: "wrapper",
                showCheckbox: "query(0).showCheckbox",
                rowSelection: handleRowSelection,
                detailPanelExpansion: handleDetailPanelExpansion,
                total: "query(0).metadata.total",
                projectModules: "query(1)",
                hideDeleteSeriesButton: true,
                toolbar: (props) => RepositoryToolbar({ hideSeriesButton: true, ...props }),
                showDetailPanel: true,
            },
        },
    ],
    routes: [],
});

const handleRowSelection = (props) => {
    return !["in_progress"].includes(props.row.Status.generationStatus);
};

const handleDetailPanelExpansion = (items) => {
    return [0, 4, 8].includes(items[0]?.status) ? ["0"] : [];
};

export default newGeneration;
